export default {
  dashboards: null,
  dashboard: null,
  layouts: []
};
